<template>
  <div class="grant-wx-div pcStyle" >
    <div data-v-96ea7c6a="" id="AuthorizedLogin">
      <div data-v-96ea7c6a="" class="speace"></div>
      <div data-v-96ea7c6a="" class="shopBox">
        <div data-v-96ea7c6a="" class="img">
          <img data-v-96ea7c6a="" class="item-img" src="https://store.aigcpop.com/static/upload/images/1/2024/09/86e931b27dccf7c565c0694067871d98.png" alt=""></div>
        <div data-v-96ea7c6a="" class="shopName">喵呜智能体</div>
      </div>
      <div data-v-96ea7c6a="" class="txt">申请获取以下权限</div>
      <div data-v-96ea7c6a="" class="txt" style="font-size: 1.19rem;">获得你的公开信息（昵称、头像等）</div>
      <div data-v-96ea7c6a="" class="btnBox">
        <button data-v-96ea7c6a="" class="van-button van-button--default van-button--normal van-button--round"
                style="margin-top: 11.72rem; background: #11762E; color: rgb(255, 255, 255);">
          <div data-v-96ea7c6a="" class="van-button__content"><span data-v-96ea7c6a=""
                                                                    class="van-button__text">授权登录</span></div>
        </button>
        <button data-v-96ea7c6a="" class="van-button van-button--default van-button--normal van-button--round"
                style="margin-top: 1.56rem; border: 1px solid #11762E; color: #11762E;">
          <div data-v-96ea7c6a="" class="van-button__content">
            <span data-v-96ea7c6a="" class="van-button__text">暂不登录</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyComponent',
  components: {},
  props: {
    test: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      sum: '0'
    }
  },
  mounted () {
    console.log('grant page mounted')
  },
  computed: {},
  methods: {
    handleClick () {
      alert('你点击了按钮')
    }
  }
}
</script>

<style lang="less" scoped>
@themeBaseColor: #11762E;
@themeLoadingColor: #11762E;

.grant-wx-div{
  width: 100vw;
  margin: 0 auto;
  @media (min-width: 430px) {
    width: 430px; /* 当页面宽度大于425px时，宽度设置为425px */
  }
}
#AuthorizedLogin{
  min-height: 100vh;
  background: #fff;
  .speace {
    height: 1rem;
    width: 100%;
  }
  .shopBox{
    margin: 0 .94rem;
    padding: .94rem 0 1.25rem 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    border-bottom: 1px solid #f0f0f1;
    .img{
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 50%;
      .item-img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .shopName {
      margin-left: .44rem;
      font-size: 1.19rem;
      font-weight: 700;
    }
  }
  .txt{
    font-size: .94rem;
    font-weight: 700;
    text-align: left;
    margin: .81rem .94rem 0 .94rem;
  }
  .btnBox {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    margin: 0 1.81rem;
    .van-button {
      height: 2.75rem !important;
    }

    .van-button--round {
      border-radius: 999px;
    }
    .van-button--default {
      color: #323233;
      background-color: #fff;
      border: 1px solid #ebedf0;
    }
    .van-button{
      position: relative;
      display: inline-block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      height: 44px;
      margin: 0;
      padding: 0;
      font-size: 16px;
      line-height: 1.2;
      text-align: center;
      border-radius: 2px;
      cursor: pointer;
      -webkit-transition: opacity .2s;
      transition: opacity .2s;
      -webkit-appearance: none;
    }

  }

}

</style>
